/* ==========================================================================
   Racket Rush - Global JavaScript
   ========================================================================== */

class BaseComponent extends HTMLElement {
  constructor() {
    super();
  }
}

// Cart Drawer Component
class CartDrawer extends BaseComponent {
  constructor() {
    super();
    this.drawer = this.querySelector('.cart-drawer');
    this.closeButton = this.querySelector('.cart-drawer__close');
    this.overlay = this.querySelector('.cart-drawer__overlay');
    this.itemsWrapper = this.querySelector('#CartDrawer-CartItems');
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    this.addEventListener('change', this.onChange.bind(this));
    this.addEventListener('click', this.onClick.bind(this));
    
    // Listen for custom event to open drawer
    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
  }

  onChange(event) {
    if (event.target.classList.contains('quantity__input')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }

  onClick(event) {
    if (event.target.classList.contains('cart-remove-button')) {
      event.preventDefault();
      this.updateQuantity(event.target.dataset.index, 0);
    }
  }

  updateQuantity(line, quantity) {
    if (this.itemsWrapper) {
      this.itemsWrapper.style.transition = 'opacity 0.2s ease';
      this.itemsWrapper.style.opacity = '0.5';
      this.itemsWrapper.style.pointerEvents = 'none';
    }

    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: 'cart-drawer'
    });

    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/javascript`
      },
      body
    })
    .then((response) => response.json())
    .then((state) => {
      this.renderContents(state.sections['cart-drawer']);

      if (this.itemsWrapper) {
        this.itemsWrapper.style.opacity = '1';
        this.itemsWrapper.style.pointerEvents = 'auto';
      }

      if (this.itemsWrapper) {
        this.itemsWrapper.style.opacity = '1';
        this.itemsWrapper.style.pointerEvents = 'auto';
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: state, skipDrawerUpdate: true }
      }));
    })
    .catch((error) => {
      console.error(error);
      if (this.itemsWrapper) {
        this.itemsWrapper.style.opacity = '1';
        this.itemsWrapper.style.pointerEvents = 'auto';
      }
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  onCartUpdated(event) {
    if (event.detail && event.detail.skipDrawerUpdate) return;
    this.open();
    this.renderContents();
  }

  renderContents(htmlString) {
    const processHtml = (text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newCartItems = html.querySelector('#CartDrawer-CartItems');
      if (newCartItems && this.itemsWrapper) {
        this.itemsWrapper.innerHTML = newCartItems.innerHTML;
      }

      const newFooter = html.querySelector('.cart-drawer__footer');
      const oldFooter = this.querySelector('.cart-drawer__footer');
      if (newFooter && oldFooter) {
        oldFooter.innerHTML = newFooter.innerHTML;
      }
    };

    if (htmlString && typeof htmlString === 'string') {
      processHtml(htmlString);
    } else {
      fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(response => response.text())
        .then(text => processHtml(text))
        .catch(e => console.error(e));
    }
  }
}
customElements.define('cart-drawer', CartDrawer);


// Listen for cart updates to update bubble count
document.addEventListener('cart:updated', (event) => {
  const cart = event.detail.cart;
  let bubble = document.querySelector('.cart-count-bubble');
  const cartLink = document.querySelector('.header-cart-link');
  
  if (cart.item_count > 0) {
    if (bubble) {
      bubble.textContent = cart.item_count;
    } else if (cartLink) {
      cartLink.insertAdjacentHTML('beforeend', `<span class="cart-count-bubble">${cart.item_count}</span>`);
    }
  } else {
    if (bubble) bubble.remove();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const cartTrigger = document.getElementById('CartDrawerTrigger');
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (cartTrigger && cartDrawer) {
    cartTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      cartDrawer.open();
    });
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    
    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Add a slight delay to ensure DOM is fully ready
    setTimeout(() => {
      this.input = this.querySelector('input[type="text"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search-results');
      
      if (!this.input || !this.predictiveSearchResults) {
        console.error("PredictiveSearch missing required DOM nodes.");
        return;
      }

      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300));
      
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.close();
        }
      });
    }, 100);
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,collection,query&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const section = parsed.querySelector('#shopify-section-predictive-search');
        
        if (section) {
          this.predictiveSearchResults.innerHTML = section.innerHTML;
          if (section.innerHTML.trim().length > 0) {
            this.open();
          } else {
            this.close();
          }
        } else {
          console.error("Predictive search section not found in response:", text);
          this.close();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[name="add"]');
    
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    // Size-gate: on product cards where a size must be chosen, clicking a size
    // pill sets the variant id then re-submits through the same form/handler
    // below — reuses the existing AJAX add-to-cart flow, no duplicate logic.
    if (this.hasAttribute('data-needs-size')) {
      this.addEventListener('click', this.onSizePillClick.bind(this));
    }
  }

  onSizePillClick(event) {
    const pill = event.target.closest('.prod-card__size-pill');
    if (!pill || pill.disabled) return;

    const variantsJsonEl = this.querySelector('.prod-card-variants-json');
    if (!variantsJsonEl) return;

    let variants;
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      console.error(e);
      return;
    }

    const optionIndex = parseInt(this.dataset.sizeOptionIndex, 10);
    const idInput = this.querySelector('input[name="id"]');
    const baseVariant = variants.find((v) => String(v.id) === String(idInput.value)) || variants[0];
    const sizeValue = pill.dataset.sizeValue;

    const match = variants.find((v) =>
      v.options[optionIndex] === sizeValue &&
      v.options.every((opt, idx) => idx === optionIndex || opt === baseVariant.options[idx])
    );
    if (!match) return;

    idInput.value = match.id;
    this.dataset.sizeSelected = 'true';

    this.querySelectorAll('.prod-card__size-pill').forEach((p) => p.classList.remove('is-selected'));
    pill.classList.add('is-selected');

    if (this.form.requestSubmit) {
      this.form.requestSubmit();
    } else {
      this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.classList.contains('loading')) return;

    // If this card needs a size and none has been picked yet, reveal the
    // size picker instead of adding the (unselected) default variant.
    if (this.hasAttribute('data-needs-size') && this.dataset.sizeSelected !== 'true') {
      const picker = this.querySelector('.prod-card__size-picker');
      if (picker) picker.hidden = false;
      return;
    }

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      }
    };

    const formData = new FormData(this.form);
    const originalContent = this.submitButton.innerHTML;
    this.submitButton.innerHTML = 'ADDING...';

    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Error handling
          return;
        }
        
        this.submitButton.innerHTML = '<span style="font-weight:900;">ADDED TO CART!</span>';
        setTimeout(() => {
          this.submitButton.innerHTML = originalContent;
        }, 2500);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && response.sections && response.sections['cart-drawer']) {
          cartDrawer.open();
          cartDrawer.renderContents(response.sections['cart-drawer']);
        }
        
        fetch(window.routes.cart_url + '.js')
          .then(res => res.json())
          .then(cart => {
             document.dispatchEvent(new CustomEvent('cart:updated', {
               detail: { cart, skipDrawerUpdate: true }
             }));
          });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
      });
  }
}
customElements.define('product-form', ProductForm);




class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('fieldset'), (fieldset) => {
      let selectedValue = '';
      const checkedRadio = fieldset.querySelector('input:checked');
      if (checkedRadio) selectedValue = checkedRadio.value;
      
      const select = fieldset.querySelector('select');
      if (select) selectedValue = select.value;

      const labelSpan = fieldset.previousElementSibling?.querySelector('span');
      if (labelSpan && selectedValue) {
        labelSpan.textContent = selectedValue;
      }
      
      return selectedValue;
    });
  }

  updateMasterId() {
    const variantsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.currentVariant = variantsData.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    if (!this.currentVariant) return;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelector(`.product__price`);
        const source = html.querySelector(`.product__price`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        
        const price = document.querySelector(`.product-form__submit span`);
        if (price) {
          if(this.currentVariant.available) {
             price.textContent = window.variantStrings.addToCart;
             document.querySelector('.product-form__submit').removeAttribute('disabled');
          } else {
             price.textContent = window.variantStrings.soldOut;
             document.querySelector('.product-form__submit').setAttribute('disabled', true);
          }
        }
      });
  }
}
customElements.define('variant-radios', VariantRadios);

class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#CollectionFiltersForm');
    if (!this.form) return;
    
    this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    
    const sortDropdown = this.querySelector('[name="sort_by"]');
    if (sortDropdown) {
      sortDropdown.addEventListener('change', this.onSubmitHandler.bind(this));
    }
  }

  debouncedOnSubmit(event) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.onSubmitHandler(event);
    }, 300);
  }

  onSubmitHandler(event) {
    if (event) event.preventDefault();
    
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;
    
    const grid = this.querySelector('.collection-grid');
    if (grid) grid.style.opacity = '0.5';

    fetch(`${url}&section_id=${this.dataset.id}`)
      .then(response => response.text())
      .then(html => {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        
        const newGrid = parsedHTML.querySelector('.collection-grid');
        if (grid && newGrid) grid.innerHTML = newGrid.innerHTML;
        
        const filters = this.querySelector('.collection-filters');
        const newFilters = parsedHTML.querySelector('.collection-filters');
        if (filters && newFilters) filters.innerHTML = newFilters.innerHTML;
        
        this.form = this.querySelector('#CollectionFiltersForm');
        this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));
        
        const sortDropdown = this.querySelector('[name="sort_by"]');
        if (sortDropdown) {
          sortDropdown.addEventListener('change', this.onSubmitHandler.bind(this));
        }

        if (grid) grid.style.opacity = '1';
        history.pushState({ searchParams }, '', url);
      })
      .catch(error => {
        console.error(error);
        if (grid) grid.style.opacity = '1';
      });
  }
}
customElements.define('collection-filters', CollectionFilters);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector('.range-slider__input--min');
    this.maxInput = this.querySelector('.range-slider__input--max');
    this.minNumber = this.querySelectorAll('input[type="number"]')[0];
    this.maxNumber = this.querySelectorAll('input[type="number"]')[1];
    
    if (this.minInput && this.maxInput) {
      this.minInput.addEventListener('input', this.updateFromSlider.bind(this));
      this.maxInput.addEventListener('input', this.updateFromSlider.bind(this));
    }
  }

  updateFromSlider(e) {
    let minVal = parseInt(this.minInput.value);
    let maxVal = parseInt(this.maxInput.value);
    
    if (minVal > maxVal) {
      if (e.target === this.minInput) this.minInput.value = maxVal;
      else this.maxInput.value = minVal;
    }
    
    this.minNumber.value = this.minInput.value;
    this.maxNumber.value = this.maxInput.value;
    
    // We trigger a change event so the CollectionFilters AJAX logic picks it up
    this.minNumber.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
customElements.define('price-range', PriceRange);

// Mobile Menu Drawer Logic
document.addEventListener('DOMContentLoaded', () => {
  const menuTrigger = document.getElementById('MobileMenuTrigger');
  const menuDrawer = document.getElementById('MobileMenuDrawer');
  const menuClose = document.getElementById('MobileMenuClose');
  const menuOverlay = document.getElementById('MobileMenuOverlay');

  if (menuTrigger && menuDrawer) {
    const openMenu = () => {
      menuDrawer.classList.add('is-open');
      menuOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };

    const closeMenu = () => {
      menuDrawer.classList.remove('is-open');
      menuOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    menuTrigger.addEventListener('click', openMenu);
    menuClose.addEventListener('click', closeMenu);
    menuOverlay.addEventListener('click', closeMenu);
  }

  // Mobile Filters Drawer Logic
  const filterTrigger = document.getElementById('MobileFilterTrigger');
  const filterAside = document.getElementById('CollectionFiltersAside');
  const filterClose = document.getElementById('MobileFilterClose');
  const filterOverlay = document.getElementById('MobileFilterOverlay');

  if (filterTrigger && filterAside) {
    const openFilters = () => {
      filterAside.classList.add('is-open');
      filterOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };

    const closeFilters = () => {
      filterAside.classList.remove('is-open');
      filterOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    filterTrigger.addEventListener('click', openFilters);
    if(filterClose) filterClose.addEventListener('click', closeFilters);
    if(filterOverlay) filterOverlay.addEventListener('click', closeFilters);
  }
});
